import React from 'react'
import { Button, Spinner, Menu, MenuItem } from '@blueprintjs/core';
import { Suggest } from '@blueprintjs/select';
import { observable, action, toJS } from 'mobx';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { Api } from 'services/Api';
import axios from 'axios';
import debounce from 'services/debounce';

const CategoryRenderer = (category, { handleClick, modifiers }) => {
  return (
    <MenuItem
      active={modifiers.active}
      key={category.id}
      label={category.attributes.title}
      onClick={handleClick}
      text={category.attributes.title}
    />
  );
};

const ListRenderer = ({ items, itemsParentRef, query, renderItem, loading, failed }) => {
  const renderedItems = items.map(renderItem).filter(item => item != null);
  return (
    <Menu ulRef={itemsParentRef}>
      {
        failed && !loading && <MenuItem disabled={true} text={'Failed to load results :('} />
      }
      {
        loading && !failed && <MenuItem disabled={true} text={'Loading..'} label={<Spinner size={20}/>} />
      }
      {
        !loading && !failed && <MenuItem
                      disabled={true}
                      text={`Found ${renderedItems.length} clients matching "${query}"`}
                    />
      }
      {renderedItems}
    </Menu>
  );
}

@observer
class ProductCategoryAutocomplete extends React.Component {

  @observable loading = true;
  @observable failed = false;
  @observable results = [];
  @observable selectedCategory = null;

  componentDidUpdate(){
    if(this.props.value){
      this.selectedCategory = this.props.value;
    }
  }

  componentDidMount() {
    let {
      selectedCategoryId
    } = this.props;

    
    if(selectedCategoryId) {     
      let promise = Api.post('/product_category/search', { search: { term: '*', where: {id: selectedCategoryId},per_page: 50, page: 1, order: { title: 'asc' } } })
      promise.then(response => {       
        this.selectedCategory = response.data.data[0];
      })
    }
    if(this.props.value){
      this.selectedCategory = this.props.value;
    }
  }

  @action
  onQueryChange(query) {
    this.failed = false;
    this.loading = true;
    if (query === '') {
      return;
    }
    let promise = Api.post('/product_category/search', { search: { term: query, per_page: 50, page: 1, order: { title: 'asc' } } })
    promise
      .then(this.onCategoryLoad.bind(this))
      .catch(this.onCategoryLoadFail.bind(this))
    return promise;
  }

  @action
  onCategoryLoadFail(error) {
    if (axios.isCancel(error)) {
      this.loading = true;
    } else {
      this.loading = false;
      this.failed = true;
    }
  }

  @action
  onCategoryLoad(response) {
    this.loading = false;
    this.failed = false;
    this.results = response.data.data;
  }

  @action
  onCategorySelect(category) {
    this.selectedCategory = category;
    this.props.onCategorySelect(category);
  }

  @action
  clearSelectedCategory() {
    this.selectedCategory = null;
    this.props.onCategorySelect(null);
  }

  render() {
    let {
      failed,
      results,
      onQueryChange,
      loading,
      onCategorySelect,
      selectedCategory,
      clearSelectedCategory,
      props: {
        inputProps
      }
    } = this;
    
    return(
      <div>
        {
          selectedCategory ? <Button 
              text={(this.selectedCategory.attributes && this.selectedCategory.attributes.title) || (this.selectedCategory && this.selectedCategory.title)} 
              rightIcon='cross'
              className="bp3-text-overflow"
              style={{display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center'}}
              onClick={clearSelectedCategory.bind(this)}
            /> : <Suggest
              inputProps={{
                icon: 'cross',
                placeholder: 'Search category...',
                ...inputProps
              }}
              closeOnSelect={true}
              openOnKeyDown={true}
              resetOnQuery={true}
              resetOnSelect={true}
              popoverProps={{ minimal: true }}
              onQueryChange={debounce(onQueryChange.bind(this)).bind(this)}
              items={toJS(results)}
              itemRenderer={CategoryRenderer}
              itemListRenderer={(props) => <ListRenderer {...props} loading={loading} failed={failed} />}
              inputValueRenderer={(category) => category.attributes.title }
              onItemSelect={onCategorySelect.bind(this)}
            />
        }
      </div>
    )
  }
}

ProductCategoryAutocomplete.propTypes = {
  inputProps: PropTypes.object,
  onCategorySelect: PropTypes.func.isRequired
}

export default ProductCategoryAutocomplete;